export const resources = {
    PERSONAL: {
        FIRST_NAME: "Zoey",
        FULL_NAME: "Zoey Arnold",
        CV: {
            FILE_URI: "Zoey Arnold CV 2025.pdf",
            FILE_NAME: "Zoey Arnold CV 2025.pdf"
        },
        SPLASH_BLURB: "I'm a Software Engineering graduate from the University of Canterbury currently temporarily based in the Nelson region, looking for an entry level position to properly kickstart my career. I'm eager to continue to learn and grow my practical skillset, and see my work make a real difference in the world.",
        SKILLS_BLURB: "As a qualified junior software engineer, I have experienced the fundamentals of a wide variety of technologies and strategies to create a strong baseline understanding of the concepts and ways of thinking required to be effective in this field without my skillset becoming rigid. Now, I have the desire to deepen my understanding and flexibility to apply myself to whatever new challenges I face, allowing me to learn rapidly. \nWith my aptitude for problem-solving I wish to help create efficient and elegant solutions that accomodate the wants and needs of the parties involved, understanding them through my receptive and empathetic communication style. I believe I can bring a calm and diverse viewpoint to any team and am eager help build the projects of the future.",
        FACE_IMAGE: "assets/blank.png"
    },
    SKILLS: [
        {   
            SKILL_NAME: "Responsive Web\nApp Development",
            FOCUS_VALUES: {
                PERSONAL: false,
                EDUCATIONAL: true,
                COMMERCIAL: true
            }
        },
        {   
            SKILL_NAME: "Database Connected\nBackends",
            FOCUS_VALUES: {
                PERSONAL: false,
                EDUCATIONAL: true,
                COMMERCIAL: true
            }
        },
        {   
            SKILL_NAME: "Videogame Testing\nAnd Debugging",
            FOCUS_VALUES: {
                PERSONAL: true,
                EDUCATIONAL: false,
                COMMERCIAL: false
            }
        },
        {   
            SKILL_NAME: "Data Reporting",
            FOCUS_VALUES: {
                PERSONAL: false,
                EDUCATIONAL: true,
                COMMERCIAL: true
            }
        },
        {   
            SKILL_NAME: "Task Automation",
            FOCUS_VALUES: {
                PERSONAL: true,
                EDUCATIONAL: true,
                COMMERCIAL: false
            }
        }
    ],
    TECH: [
        "Java",
        "Python",
        "MySQL",
        "Angular",
        "Vue",
        "Typescript",
        "Git",
        "Docker",
        "Csharp",
        "Amplify",
        "MongoDB",
        "PowerBI"
    ],
    PROJECTS:[
        {
            Name: "All"
        },
        {
            Name: "Permissions",
            ExpandedViewTitle: "Permission Modernization",
            ExpandedViewBodyText: "At my internship at Allied Telesis, I undertook a project to modernize aspects of the user permissions system in their flagship network management software product, Vista Manager. This involved utilizing full stack development skills, managing complex data flows through various layers between a responsive web application frontend built with Typescript and Angular and a mongoDB database while remaining conscious of security, network efficiency and internal company coding guidelines.\nThis project was also an excellent experience in working within Agile development strategies, facilitating open communication and tracking of progress within the team through regular standup meetings and the use of JIRA for task breakdown and arisen issues, and maintaining a high quality deliverable product with a DevOps system of code reviews through version control systems and automated testing and analysis pipelines to pass before publishing.\nThrough these strategies, I was able to create robust new options for user permission control through assigning groups of users and devices within Vista Manager that met the needs of the project while enhancing my full stack development skillset and consciousness of good development practices.",
            CircleViewTitle: "Permission Modernization"
        },
        {
            Name: "Council",
            ExpandedViewTitle: "Data Management\nat Tasman Council",
            ExpandedViewBodyText: " During my internship at the Tasman District Council, I had the opportunity to work alongside their IT team as they undertook the project of migrating many of the council’s existing records and systems to a modern infrastructure system with Microsoft Azure cloud services with the aim of improving future workflows and maintainability.\nMy personal project to assist with the migration involved reviewing the councils existing collection of Microsoft SSRS reports and identifying the issues within each as many had become nonfunctional over time due to system and environment changes, migrating them to the new Azure system and reattaching the appropriate database connections with the corresponding new copies of the data in Azure. In cases where the reports' function had more severely degraded, I personally liaised with the relevant parties within other departments of the council to arrange and implement situationally appropriate solutions.\nFurthermore, once this project was completed, I undertook the additional task of creating a new reporting page for one such department utilizing Microsoft PowerBI. This involved working directly alongside a product client to identify and meet their specific needs and self-driven learning of new technology in order to deliver a satisfactory end product.",
            CircleViewTitle: "Council Data Management"
        },
        {
            Name: "Reborn",
            ExpandedViewTitle: "Game Testing\nand Debugging",
            ExpandedViewBodyText: "Over the years in my spare time, I have become involved in the community at Reborn, Evolved working on and around the passion project fangame ‘Pokemon Reborn’. \nInitially I joined simply as a community member through enjoyment of the game to participate as a fan, but before long I was identified and reached out to with an offer to join the team behind it. Initially this was a position helping with community moderation and management, where I helped to foster a friendly and inclusive environment and grew my communication and mediation skills by working and interacting with a wide variety of people from around the world. I was also involved in the internal testing process of the game, operating in a high trust environment and working to identify and clearly communicate bugs to the developers through targeted playtesting. \nLater in the process, I proved my self-driven learning of the game’s internal Ruby codebase and was brought in to collaborate with the development team itself on the debugging process for the polishing phase of the public release. This involved working collaboratively with the team to identify and fix the underlying causes of bug submissions from community members. Together, we helped create a rich and polished game experience for the community.",
            CircleViewTitle: "Reborn \nGame Testing"
        }
    ],
    CONTACT:{
        linkedin: {
            URL: "https://www.linkedin.com/in/zoey-arnold-719368391"
        },
        github: {
            URL: "https://github.com/ZoeyStardream"
        },
        gmail: {
            URL: "mailto:zoeystardream@gmail.com" 
        },
        facebook: {
            URL: "https://www.facebook.com/zoey.arnold.95262/"
        }
    }
}